function getIcon(activeAbility) {
    switch (activeAbility) {
        case 9003592:
            return '/liveGameIcons/unique/macedonian/atgeir.png'
        case 9001672:
            return '/liveGameIcons/unique/macedonian/varangian.png'
        case 9001671:
            return '/liveGameIcons/unique/macedonian/bogmadr.png'
        case 9001673:
            return '/liveGameIcons/unique/macedonian/riddari.png'
        case 9004101:
            return '/liveGameIcons/unique/macedonian/war_galley.png'
        case 9004097:
            return '/liveGameIcons/unique/macedonian/general_ship.png'
        default:
            return undefined

    }
}

export function MacedonianWarcamp({ threshold, current, leftSide, activeAbility }) {
    let icon = getIcon(activeAbility) || activeAbility
    return (
        <div className="flex flex-row w-[84px] h-[40px] justify-center border-solid border" style={{
            backgroundImage: `url(/liveGameIcons/BACKGROUND.png)`,
            borderColor: 'var(--main-color)'
        }}>
            <div className="flex flex-col text-center my-auto w-[48px] text-white">
                {threshold - current}
            </div>
            <div className="h-[38px] w-[38px]" style={{ backgroundImage: 'url(/liveGameIcons/empty_background.png)' }}>
                <img className="h-[38px] w-[38px]" src={icon} alt="" />
            </div>
        </div>
    )
}